import type OwaUserConfiguration from "owa-service/lib/contract/OwaUserConfiguration";
import { updateServiceConfig } from "owa-service/lib/config";
import type { GetTimeZoneOverrides } from "owa-datetime-store";
import { initializeOwaDateTimeStore, updateOwaDateTimeStore } from "owa-datetime-store";
import { initializeOwaObservableDateTime } from "owa-observable-datetime";
import getUserConfiguration from "owa-session-store/lib/actions/getUserConfiguration";
import type TimeZoneEntry from "owa-service/lib/contract/TimeZoneEntry";
import type TimeZoneOffsetsType from "owa-service/lib/contract/TimeZoneOffsetsType";

/**
 * Initialize the date time store (use in boot scenarios)
 * @param userConfig
 * @param shouldInitializeTimeZoneAnonymously
 */
export default function initializeDateTime(shouldInitializeTimeZoneAnonymously?: boolean, getTimeZoneOverrides?: GetTimeZoneOverrides): Promise<[
    TimeZoneOffsetsType[] | undefined,
    TimeZoneEntry[] | undefined
]> {
    const userOptions = getUserConfiguration()?.UserOptions;
    updateServiceConfig({ timezone: userOptions?.TimeZone });
    const promise = initializeOwaDateTimeStore(userOptions, shouldInitializeTimeZoneAnonymously, getTimeZoneOverrides);
    initializeOwaObservableDateTime();
    return promise;
}

/**
 * Update the date time store (use on user update )
 * @param userConfig
 */
export function updateDateTime(userConfig: OwaUserConfiguration): void {
    const userOptions = userConfig?.UserOptions;
    updateServiceConfig({ timezone: userOptions?.TimeZone });
    updateOwaDateTimeStore(userOptions);
    initializeOwaObservableDateTime();
}
